import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getSlot, scaffoldModuleTypes } from 'layout/utils-show-hide.js';
import { ISecondarySlotConfig, ISecondarySlotPropsMap } from 'redux-state/layout/types.layout.js';
import { ModulePath } from '../../utilities/modulePath/modulePath.js';
import { SecondaryModulesState } from './types.js';

const initialState: SecondaryModulesState = {
  secondaryMajor: [],
  secondaryMinor: [],
  secondaryRight: [],
};

/** also used by nextjs prototype */
export const convertSecondaryModules = (slots: ISecondarySlotPropsMap): SecondaryModulesState => {
  const secondaryMajor = scaffoldModuleTypes(getSlot(slots.major).modules);
  const secondaryMinor = scaffoldModuleTypes(getSlot(slots.minor).modules);
  const secondaryRight = scaffoldModuleTypes(getSlot(slots.right).modules);
  return {
    secondaryMajor,
    secondaryMinor,
    secondaryRight,
  };
};

export const isSecondaryModule = (modulePath: ModulePath): boolean => {
  switch (modulePath) {
    case ModulePath.SECONDARY_MAJOR:
    case ModulePath.SECONDARY_MINOR:
    case ModulePath.SECONDARY_RIGHT:
      return true;
    default:
      return false;
  }
};

/**
 * This is the first stage of transitioning all module data from layout into its own data structure
 * As / If this is used beyond secondary elements then these need to be added and properly handled
 * Used here src/layout/sections/secondary-section/secondary-layout.jsx
 *  const secondaryConfig = useSelector((state: IRepoState) => state.MODULES);
 */

export const secondaryModulesSlice = createSlice({
  name: 'modules',
  initialState,
  reducers: {
    REDUX_SECONDARY_MODULES_SET: (_, action: PayloadAction<ISecondarySlotConfig>) => {
      const secondaryMajor = scaffoldModuleTypes(getSlot(action.payload.slots.major).modules);
      const secondaryMinor = scaffoldModuleTypes(getSlot(action.payload.slots.minor).modules);
      const secondaryRight = scaffoldModuleTypes(getSlot(action.payload.slots.right).modules);
      return {
        secondaryMajor,
        secondaryMinor,
        secondaryRight,
      };
    },

    REDUX_SECONDARY_MODULES_CLEAR: () => {
      return initialState;
    },
  },
});

export const { REDUX_SECONDARY_MODULES_SET, REDUX_SECONDARY_MODULES_CLEAR } = secondaryModulesSlice.actions;

export const secondaryModulesReducer = secondaryModulesSlice.reducer;
